<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <!-- TODO add Permission-->
  <button
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="addAssetCategory()"
    sbTooltip="{{ 'lang.globals.assetCategory.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

  side panel / Edit/Create

-------------------------------->

<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="600">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    <h4 *ngIf="selectedAssetCategory" [innerHTML]="selectedAssetCategory?.name | truncate : 30"></h4>
    <h4 *ngIf="!selectedAssetCategory">{{ 'lang.globals.newFile' | translate }}</h4>
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-asset-category-edit [assetCategory]="selectedAssetCategory" [repositoryId]="repositoryId"
                               (saveClick)="updateAssetCategory(selectedAssetCategory)"></sb-page-asset-category-edit>
</ng-template>


<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.assetCategories' | translate}}"
  [isInIntegratedContext]="true"
  [itemsData]="assetCategories"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'assetCategories'">

  <!------------------------------

      Filter Panel

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.parent' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-assetCategory>

    <tr>
      <td>
        {{ assetCategory?.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <span firstLine class="cursor-pointer" (click)="!isInModalContext? editAssetCategory(assetCategory): ''"
                [innerHtml]="assetCategory?.name|truncate:30"></span>
        </sb-comp-name-wrapper>
      </td>
      <td>
          <span *ngIf="assetCategory?.parent" class="cursor-pointer"
                (click)="!isInModalContext? editAssetCategory(assetCategory.parent) : ''"
                [innerHtml]="assetCategory?.parent?.name"></span>
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext) {
          @if (!assetCategory.global) {
            <sb-split-button
              [splitButtonItems]="assetCategory.sbButtons ?? []"
              (selectedAction)="resolveSplitButtonAction(assetCategory, $event)"
            ></sb-split-button>
          }
        } @else {
          <button sb-button-secondary
                  type="button"
                  ngbTooltip="{{'lang.globals.select' | translate}}"
                  (click)="selectAssetCategory(assetCategory)"
                  [icon]="'boxChecked'"
                  [color]="'blue'"
                  [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
